import './AddAction.scoped.scss'
import { useAct } from 'FlowBuilder/store'

const flowActions = [
  { kind: 'survey', name: 'Survey', description: 'Complete a survey', icon: <SvgIconsCircleQuestion /> },
  { kind: 'share', name: 'Share', description: 'Share on social media', icon: <SvgIconsShare /> },
  { kind: 'donate', name: 'Donation', description: 'Donate to a campaign', icon: <SvgIconsDonate /> },
  { kind: 'redirect', name: 'Redirect', description: 'Redirect to a URL', icon: <SvgIconsLink width={32} height={32} viewBox="0 0 14 2" fill="#F0C266" /> },
  { kind: 'lunda', name: 'Lunda Donation', description: 'Collect donations', icon: <SvgIconsDonate /> },
  { kind: 'fundraise_up', name: 'Fundraise Up Donation', description: 'Collect donations', icon: <SvgIconsDonate /> },
  { kind: 'custom', name: 'Custom', description: 'Custom step', icon: <SvgIconsRichText /> }
]

export default function AddAction() {
  const act = useAct()
  const [availableActions, setAvailableActions] = useState([])

  useEffect(() => {
    act.actions.loadAvailable().then((actions) => {
      setAvailableActions(actions)
    })
  }, [])

  function addAction(kind) {
    return () => {
      act.actions.add({ kind, name: _.capitalize(kind), active: true })
      act.local.closeModal()
    }
  }

  const hasSurvey = useSel((s) => !!Object.values(s.actions.entities).find((action) => action.kind === 'survey'))

  function canShow(kind) {
    // in the future, we want to allow people to add a second survey, so remove the first condition when appropriate
    return !(kind === 'survey' && hasSurvey) && availableActions.includes(kind)
  }

  return (
    <div className="action-types">
      {flowActions.map((action) => {
        if (!canShow(action.kind)) return

        return (
          <a className="card large selectable text-align-center" onClick={addAction(action.kind)} key={action.kind}>
            {action.icon}
            <h2>{action.name}</h2>
            <p>{action.description}</p>
          </a>
        )
      })}
    </div>
  )
}
